
export default {
  methods: {
    mailTo(orderNumber) {
      return `mailto:${this.i18n('customer_support_email_cc')}?subject=${this.i18n('contact_support_email')} ${orderNumber}`;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/mailto.js